<template>
  <el-card class="sapce-pending">
    <div slot="header">
      <el-tabs v-model="activeName" class="space-tab" @tab-click="changTab">
        <el-tab-pane label="代处理" name="wait"></el-tab-pane>
        <el-tab-pane label="已处理" name="end"></el-tab-pane>
        <el-tab-pane label="我指派" name="pub"></el-tab-pane>
      </el-tabs>

      <el-button
        class="add-button"
        v-show="activeName != 'end'"
        type="success"
        plain
        icon="el-icon-plus"
        size="small"
        @click="showAddDialog"
        title="新建"
      ></el-button>

      <el-input placeholder="请输入标题" size='small' class="pending-search" v-model="searchTitle" @keyup.enter.native="searchByTitle">
        <el-button slot="append" icon="el-icon-search" title="搜索" @click="searchByTitle"></el-button>
      </el-input>
    </div>

    <div
      class="space-pending-box"
      :style="'height:' + (this.$tools.mainHeight() - 165) + 'px'"
      v-infinite-scroll="next"
      :infinite-scroll-disabled="disabled()"
      infinite-scroll-delay="1000"
    >
      <el-card class="sapce-pending-item" v-for="(p, i) in records" :key="i">
        <div class="sapce-pending-item-title">
          <el-row>
            <el-col :span="3"><el-badge class="sapce-pending-item-badge" :value="getDays(p.planEndTime)" :type="p.planEndTime > new Date() ? 'success' : 'danger'" v-show="p.rate < 100"></el-badge></el-col>
            <el-col :span="19"><p class="item-title-p" @click="getTask(p.id, false)">{{ p.title }}</p></el-col>
            <el-col :span="2"><span v-if ="p.hasFile == 'Y'"><i @click="showFile(p.id)" class="el-icon-paperclip item-title-paperclip"></i></span></el-col>
          </el-row>
        </div>
        <div class="sapce-pending-item-time">
          {{ $tools.timestampToDay(p.planStartTime) }} ~ {{
            $tools.timestampToDay(p.planEndTime)
          }}
        </div>

        <div class="sapce-pending-item-main">
          <el-progress
            :text-inside="true"
            :stroke-width="20"
            :percentage="p.rate"
            :status="p.rate >= 100 ? 'success' : (p.planEndTime < new Date() ? 'exception' : null)"
          ></el-progress>
        </div>
        <div class="sapce-pending-item-button">
          <div class="sapce-pending-item-user">
            {{ p.publisherName }} 指派<span v-if="!!p.actualEndTime">并完成于 {{$tools.timestampToDay(p.actualEndTime)}}</span>
          </div>

          <!-- 未完成的任务才有按钮 -->
          <el-button v-if="showButton && p.rate < 100"
            title="编辑任务"
            icon="el-icon-edit"
            circle
            size="mini"
            @click="getTask(p.id, true)"
          ></el-button>

          <!-- 未完成的任务并且是自己发布的才有删除按钮 -->
          <el-button v-if="showButton && p.rate < 100 && p.userId == p.publisher"
            title="删除任务"
            icon="el-icon-delete"
            circle
            size="mini"
            @click="deleteTask(p.id)"
          ></el-button>
        </div>
      </el-card>
      <div class="sapce-pending-more">
        <p v-if="!disabled()">加载中....</p>
        <p v-if="disabled()">没有更多了...</p>
      </div>
    </div>

    <el-dialog
      :title="task.id ? (canEdit ? '修改任务' : '查看任务') : '新建任务'"
      :visible.sync="showDialog"
      width="500px"
      @closed="refeshRule"
    >
      <el-form
        ref="taskForm"
        :model="task"
        :rules="rules"
        label-width="80px"
        label-position="left"
      >
        <el-form-item label="任务名称" prop="title">
          <el-input v-model="task.title" :disabled="!!task.id || !canEdit"></el-input>
        </el-form-item>
        <el-form-item label="任务描述" prop="content">
          <el-input type="textarea" v-model="task.content" :disabled="!!task.id || !canEdit"></el-input>
        </el-form-item>

        <el-form-item label="计划时间" prop="time">
          <el-col :span="11">
            <el-date-picker
              type="date"
              placeholder="选择计划开始日期"
              v-model="task.planStartTime"
              style="width: 100%" :disabled="!!task.id || !canEdit"
            ></el-date-picker>
          </el-col>
          <el-col :span="1">~</el-col>
          <el-col :span="11">
            <el-date-picker
              type="date"
              placeholder="选择计划结束日期"
              v-model="task.planEndTime"
              style="width: 100%" :disabled="!!task.id || !canEdit"
            ></el-date-picker>
          </el-col>
        </el-form-item>

        <el-form-item label="发布人" v-show="!!task.id">
          <el-input v-model="task.publisherName" disabled></el-input>
        </el-form-item>

        <el-form-item label="指派给" prop="userId">
          <sn-user-search-input :defaultId="task.userId" :defaultName="task.userName" :disabled="!canEdit"
            @change="
              (a) => {
                task.userId = a;
              }
            "
          ></sn-user-search-input>
        </el-form-item>

        <el-form-item label="完成率" prop="rate" v-show="!!task.id">
          <el-input-number v-model="task.rate" :disabled="!canEdit" controls-position="right" :min="0" :max="100" :precision="0"></el-input-number>
        </el-form-item>

        <el-form-item label="完成时间" v-show="!!task.id && !!task.actualEndTime">
          <el-input :value="$tools.timestampToTime(task.actualEndTime)" disabled></el-input>
        </el-form-item>

        <el-form-item label="完成情况" v-show="!!task.id">
          <el-input type="textarea" v-model="task.remark" :disabled="!canEdit"></el-input>
        </el-form-item>

      <sn-file-upload  :relateId="task.id" relateType="Task" :files.sync="task.files" :disabled="!canEdit" v-if="canEdit" :userId="$cookies.get('U_ID')"></sn-file-upload>
      </el-form>

      <div slot="footer" class="dialog-footer" v-if="canEdit">
        <el-button size="small" @click="showDialog = false">取消</el-button>
        <el-button
          class="save-button"
          type="primary"
          size="small"
          @click="create"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <sn-file-dialog :show.sync="showFileDialog" :relateId="relateId" relateType="Task" :canEdit="false"></sn-file-dialog>
  </el-card>
</template>

<script>
import SnFileDialog from '../components/SnFileDialog.vue';
import SnFileUpload from '../components/SnFileUpload.vue';
import SnUserSearchInput from "../components/SnUserSearchInput.vue";

export default {
  components: { SnUserSearchInput, SnFileDialog, SnFileUpload},
  data() {
    var checkTime = (rule, value, callback) => {
      if (!this.task.planStartTime || !this.task.planEndTime) {
        callback(new Error("开始和结束时间都不能为空"));
      } else if (this.task.planStartTime > this.task.planEndTime) {
        callback(new Error("开始时间不能大于结束时间"));
      } else {
        callback();
      }
    };

    return {
      showDialog: false,
      showButton: false,
      showFileDialog: false,
      canEdit: false,
      selectId: null,
      activeName: "wait",
      searchTitle: null,
      records: [],
      task: {},
      page: {},
      rules: {
        title: [
          { required: true, message: "请输入标题", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "长度在 2 到 20 个字符",
            trigger: "blur",
          },
        ],
        content: [
          { required: true, message: "请输入任务描述", trigger: "blur" },
          {
            min: 2,
            max: 40,
            message: "长度在 2 到 40 个字符",
            trigger: "blur",
          },
        ],
        time: [{ validator: checkTime, required: true, trigger: "blur" }],
      },

      relateId: null
    };
  },
  methods: {
    disabled() {
      return this.page.current >= this.page.pages || this.page.total == 0;
    },
    next() {
      this.page.current = this.page.current + 1;
      this.search();
    },
    changTab() {
      this.searchTitle = null;
      this.page = {};
      this.records = [];
      this.search();
    },
    searchByTitle() {
      this.page = {};
      this.records = [];
      this.search();
    },
    showAddDialog() {
      this.task = {};
      this.canEdit = true;
      this.showDialog = true;
    },
    search() {
      let _this = this;

      let task = {};

      if (_this.searchTitle) {
        task["title"] = _this.searchTitle;
      }

      if (_this.activeName == "wait") {
        task["userId"] = _this.$cookies.get("U_ID");
        task["rate"] = "-1";
        this.showButton = true;
      } else if (_this.activeName == "end") {
        task["userId"] = _this.$cookies.get("U_ID");
        task["rate"] = "100";
        this.showButton = false;
      } else {
        task["publisher"] = _this.$cookies.get("U_ID");
        delete task.rate;
        this.showButton = true;
      }

      _this.$http.post(
        ["task/page", _this.page, task],
        [
          function (page) {
            _this.page = page;
            _this.records = _this.records.concat(page.records);
          }, function() {
            _this.page.total = 0;
          }
        ],
        ".space-pending-box"
      );
    },
    getDays(planEndTime) {
      let days = 0;

      let pd = this.$tools.timestampToDay(planEndTime);
      let nd = this.$tools.dateToDay(new Date());

      days = (Date.parse(pd) - Date.parse(nd)) / 1000 / 60 / 60 /24;

      if (days < -9) {
        return '-9d+';
      } else if (days > 9) {
        return '9d+';
      } else {
        return days + 'd';
      }
    },
    create() {
      let _this = this;
      let url = null;
      let p = null;

      if (_this.task.id) {
         url = "task/update";

         _this.task = {
           rate: _this.task.rate,
           id: _this.task.id,
           userId: _this.task.userId,
           remark: _this.task.remark
         }
         
         p = Promise.resolve();
      } else {
         url = "task/create";
        p = this.$refs["taskForm"].validate();
      }

      p.then(() => {
        _this.$http.post(
          [url, _this.task],
          [
            function () {
              _this.showDialog = false;
              _this.changTab();
            },
          ],
          ".save-button"
        );
      });
    },
    deleteTask(id) {
       let _this = this;

      _this.$tConfirm.show("确认删除任务？", function () {
          _this.$http.post(
            ["task/delete", id],
            [
              function () {
                _this.changTab();
              },
            ],
            ".sapce-pending-item"
          );
      });
    },
    getTask(id, canEdit) {
      let _this = this;

      _this.canEdit = canEdit;

      _this.$http.post(
        ["task/get", id],
        [
          function (data) {
            _this.task = data;
            _this.showDialog = true;
          },
        ],
        ".save-button"
      );
    },
    showFile(id) {
      let _this = this;
      _this.relateId = id;
      _this.showFileDialog = true;
    },
    refeshRule() {
       this.$refs["taskForm"].resetFields();
    }
  },
};
</script>

<style lang="scss" scoped>
.sapce-pending {
  margin: 10px;

  .pending-search {
    width: 250px;
  }

  .space-tab {
    width: 90%;
  }

  .add-button {
    float: right;
    cursor: pointer;
  }

  .space-pending-box {
    overflow-y: auto;

    .sapce-pending-more {
      clear: both;
      text-align: center;
      font-size: 14px;
      color: #c0c4cc;
    }
  }

  .sapce-pending-item {
    margin: 1%;
    width: 30%;
    height: 108px;
    float: left;

    .sapce-pending-item-title {
      overflow: hidden;
      height: 22px;

      .item-title-p {
        margin: 0;
        text-overflow: ellipsis;
        overflow: hidden;
        height: 20px;
        cursor: pointer;
      }

      .item-title-p:hover {
        color:#66b1ff;
      }

      .item-title-paperclip {
        margin-top: 2px;
        cursor: pointer;
      }
    }

    .sapce-pending-item-badge {
      margin: 1px 2px 0 0;
    }

    .sapce-pending-item-time {
      height: 18px;
      font-size: 12px;
      color: #c0c4cc;
    }
    .sapce-pending-item-main {
      height: 22px;
    }

    .sapce-pending-item-button {
      .el-button {
        float: right;
        margin-left: 5px !important;
        margin-top: 3px;
      }
      .sapce-pending-item-user {
        float: left;
        font-size: 14px;
        height: 18px;
        margin-top: 7px;
        font-size: 12px;
        color: #c0c4cc;
      }
    }
  }
}
</style>